import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFiltersInPage } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { MilestoneFragnetFilter } from 'components/common/GlobalFiltersInPage/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { GlobalFilterFieldKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader } from 'components/common';
import { FinishDateFuturePotentialDelayDriversWrapper } from 'components/widgets/FinishDateFuturePotentialDelayDrivers/FinishDateFuturePotentialDelayDriversWrapper';
import { FinishDateOverallSummary } from 'components/widgets/FinishDateOverallSummary/FinishDateOverallSummary';
import { FinishDatePredictionCompletionPlanWrapper } from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlanWrapper';

export const FinishDatePredictionPage = () => {
    useFullStoryPageView({ pageName: riskConfig.finishDatePrediction.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <GlobalFilterButton />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.finishDatePrediction.title} />
                    <GlobalFiltersInPage defaultValues={{ [GlobalFilterFieldKey.milestoneFragnet]: null }}>
                        <MilestoneFragnetFilter name={GlobalFilterFieldKey.milestoneFragnet} />
                    </GlobalFiltersInPage>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <FinishDateOverallSummary />
                    <FinishDatePredictionCompletionPlanWrapper />
                    <FinishDateFuturePotentialDelayDriversWrapper />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal
                queryKeys={['activityCompletionPlan', 'futurePotentialActivities', 'activityPrediction']}
            />
        </PageContainer>
    );
};
